import React, {useState} from 'react';

import
  PropTypes
from 'prop-types';
import {
  HFlexContainer,
  Input,
  InputContainer,
  InputLabel,
  OptionalText,
  RegularUnderlinedText,
  SmallText,
  SpaceInbetweenSection,
  SvgIcon,
  ForgotCredential
} from './TextField.styles';

import warningIcon from '../../../images/warning.svg';
import tooltipIcon from '../../../images/info-circle.svg';
import hidePasswordIcon from '../../../images/hide-password.svg';
import showPasswordIcon from '../../../images/show-password.svg'


export const TextField = (props) => {

  const [localShowPassword, setLocalShowPassword] = useState(false);

  const handleForgotClick = () => {
    if (props.fieldType === 'username') {
      props.callForgotUsername();
    } else if (props.fieldType === 'password') {
      props.callForgotPassword();
    }
  };

  const handleToggleShowPassword = () => {
    if (props.fieldType === 'password') {
      setLocalShowPassword((prev) => !prev);
    }
  };


  return (
    <div style={{ 'gap': '8px',
    'display': 'flex',
    'flexDirection': 'column',
    'aligItems': 'flex-start',
    'alignSelf': 'stretch'}}>
      <InputLabel>
<SpaceInbetweenSection>

        <div style={{ 
          'display': 'flex',
          'alignItems': 'baseline',
          'gap': '4px',
          'alignSelf': 'stretch',
          'flexWrap': 'wrap',
          'justify-content': 'space-between'
        }}>
          {props.inputLabel}
          {props.mainImage &&
              <img width={props.imageWidth} height={props.imageHeight} src={props.mainImage} alt={props.imageAlt}/>}
          <OptionalText>{props.optionalText}</OptionalText>
        </div>
  {
      props.forgotLink &&
          <RegularUnderlinedText color='#141827' onClick={props.forgotLink}>Forgot?</RegularUnderlinedText>
        }
      </SpaceInbetweenSection>

        
        <InputContainer>
          <Input isError={props.isError}
                 id={props.inputLabel.replace(/ /g, '_').replace('/', '_')}
                 placeholder={props.placeholder}
                 onChange={props.onChange}
                 value={props.value}
                 onKeyPress={props.onKeyPress}
                 type={props.fieldType === 'password' ? (localShowPassword ? "text" : "password") : props.inputType}
                 disabled={props.disableField}/>

          {!props.showPassword &&
        
            <SvgIcon
              automationid='LoginPage_Svg_ClickableIcon'
              onClick={handleToggleShowPassword}>

                {
                  localShowPassword ?
                  <img  width={'100%'} src={ showPasswordIcon } alt="LOGO"/>
                  :
                  <img  width={'100%'} src={ hidePasswordIcon } alt="LOGO"/>
                }
            </SvgIcon>
          }

        </InputContainer>
      </InputLabel>
      {
        ((props.isError && props.inLineMessage) || props.fieldInfo) ?

        <HFlexContainer>
          <div style={{
            'display': 'flex',
            'paddingTop': '2.5px',
            'alignItems': 'flex-start',
            'gap': '10px'
          }}> 
            <img width={'16px'} height={'16px'} src={warningIcon} alt='warning'/>
          </div>
          {
            <SmallText isError={props.isError} id={props.inputLabel.replace(' ', '_')}> {/*pass in as prop */}
              {props.inLineMessage}
            </SmallText>
          }

        </HFlexContainer> : <>
        {
          (props.toolTipInfo) &&
          <HFlexContainer>
          <div style={{
            'display': 'flex',
            'paddingTop': '2.5px',
            'alignItems': 'flex-start',
            'gap': '10px'
          }}> 
            <img width={'16px'} height={'16px'} src={tooltipIcon} alt='info'/>
          </div>
          {
              <SmallText>{props.toolTipInfo}</SmallText>
          }
        </HFlexContainer>
        }
        </>
      }
    </div>
  );
};

TextField.propTypes = {
  inputLabel: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  inLineMessage: PropTypes.string,
  setInLineMessage: PropTypes.func,
  infoObj: PropTypes.object,
  showPassword: PropTypes.bool,
  isLogin: PropTypes.bool,
  fieldType: PropTypes.oneOf(['username', 'password']),
  callForgotUsername: PropTypes.func,
  callForgotPassword: PropTypes.func,
  toggleShowPassword: PropTypes.func,
};

TextField.defaultProps = {
  inputLabel: '',
  isLogin: false,
  placeholder: '',
  showPassword: true,
  onChange: () => {},
  onClick: () => {},
  inLineMessage: '',
  setInLineMessage: () => {},
  currentElementID: '',
  infoObj: {},
  fieldType: '',
  callForgotUsername: () => {},
  callForgotPassword: () => {},
  toggleShowPassword: () => {},
};
